
import Vue from "vue";
import store from "@/store";

export default Vue.extend({
  name: "StatueHistoryComponent",

  data() {
    return {
      defaultImage: require("@/assets/img/default-product.jpg"),
      url: "https://webapi.vip-chef.ir/images/landing/",
    };
  },

  computed: {
    statues() {
      return store.state.admin.landing.homePage.statues;
    },
  },

  methods: {
    banner(image: string) {
      if (image !== "") {
        return this.url + image;
      } else {
        return "";
      }
    },

    deleteStatue(id: string): void {
      store.dispatch("admin/deleteStatue", id);
    },
  },

  created() {
    store.dispatch("admin/getStatues");
  },
});
